export default __webpack_public_path__ + "static/image/slider3.0c937fcc.jpg";